import React from "react";
import {
  Box,
  Autocomplete,
  TextField
} from "@mui/material";
import { optionsAvailable } from "pages/AddWorker/components/utils";
import WeekPicker from "pages/Timesheet/WeekPicker";
import MonthPicker from "../MonthPicker";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { properCase } from "utils";
import Seperator from "components/Seperator";

export default function InspectionHeader ({view, setView, month, setMonth, startDate, setStartDate, setInspectionType}){
 const { t } = useTranslation();
 const inspectionTypeOptions = ['inbound', 'outbound'];

  const handleViewChange = (e, newValue) => {
    setView(newValue);
  };

  const handleInspectionTypeChange = (e, newValue) => {
    setInspectionType(newValue);
  };

  const monthChangeHandler = (date) => {
    console.log("ReportHeader > MonthPicker value changed===", date);
    setMonth(date);
    setStartDate(date);
  };

  const weekChangeHandler = (date) => {
    setStartDate(date);
  };

  return (
    <>
       {/* Filters */}
        <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
          <Autocomplete
            id="selection"
            disableClearable
            options={optionsAvailable}
            defaultValue={optionsAvailable[0]}
            getOptionLabel={(option) => option ?
              option === "Weekly" ?
              properCase(t("other.lblWeekly")) :
              option === "Monthly" ?
              properCase(t("other.lblMonthly")) :
              option :
              "NA"
            }
            style={{ width: 150 }}
            renderInput={(params) => (
              <TextField
                required={true}
                {...params}
                label={properCase("View")}
                variant="outlined"
                size="small"
              />
            )}
            onChange={handleViewChange}
          />

            {
            //for monthly view display month picker otherwise display week picker component
            view === "Monthly" ? (
              <MonthPicker
                startMonth={month}
                monthChangeHandler={monthChangeHandler}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={properCase("Month")}
                    size="small"
                    variant="outlined"
                  />
                )}
                minDate={moment("2025-01-01").startOf("day")}
                maxDate={moment(new Date()).endOf("day")}
              />
            ) : (
              <WeekPicker
                size="small"
                variant="outlined"
                weekChangeHandler={weekChangeHandler}
                startDate={startDate}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    label={properCase("Week")}
                    size="small"
                    variant="outlined"
                  />
                )}
                minDate={moment("2025-01-01").startOf("day")}
                maxDate={moment(new Date()).endOf("day")}
              />
            )
          }

          <Autocomplete
              id="inspectionType"
              disableClearable
              options={inspectionTypeOptions}
              defaultValue={inspectionTypeOptions[0]}
              getOptionLabel={(option) => properCase(option)}
              style={{ width: 180 }}
              renderInput={(params) => (
                <TextField
                  required={true}
                  {...params}
                  label={"Inspection Type"}
                  variant="outlined"
                  size="small"
                />
              )}
              onChange={handleInspectionTypeChange}
            />
        </Box>
        <Seperator />
    </>
  )
}